<div class="confirm-modal-popup">
  <span class="material-icons close-icon-modal position-absolute" (click)="closeDialog()">close</span>
  <img src="assets/images/check-icon.svg" alt="check-icon" class="modal-icon">
  <h2 *ngIf="this.data.title && this.data.title !== 'Confirm' && this.data.title !== 'Confirmation' && this.data.title !== 'Bid Submitted!'" class="modal-title">{{this.data.title}}</h2>
  <div class="modal-message">
    <p class="f-16 pb-0 mb-0" [innerHTML]="this.data.description"></p>
  </div>
  <div class="modal-actions">
    <button (click)="onClickYes()" mat-button class="btn rounded_btn green_btn small_btn px-4 fw-400">Yes</button>
    <button (click)="onClickNo()" mat-button class="btn rounded_btn cancel_btn small_btn px-4 fw-400">No</button>
  </div>
</div>